
export const pharam_heading = [
    {
        title: "Solution For Healthcare and "      
    },
    {
        title: "Pharmaceutical"      
    },
   
  ]; 